import {
  Card,
  Text,
  FormLayout,
  InlineStack,
  Thumbnail,
  Select,
  Button,
  Divider,
} from "@shopify/polaris";
import styles from "../../styles/layouts/Bundles/Bundles.module.css";
import DimensionBox from "../Common/DimensionsBox";

const SelectedProductsItems = ({
  selectedProducts,
  selectedBox,
  boxes,
  editable,
  handleVariantChange,
  handleDimensionChange,
  handleProductSelection,
  handleAddProducts,
  setSelectedBox,
  disabled,
}) => {
  return (
    <Card title="Bundle Products" sectioned>
      {!selectedProducts.length ? (
        <Text as="h3" variant="bodyMd" tone="subdued">
          Select At least one product
        </Text>
      ) : (
        ""
      )}
      <FormLayout>
        {selectedProducts &&
          selectedProducts.length &&
          selectedProducts.map((selectedProduct) => {
            const { product } = selectedProduct;
            return (
              <>
                <InlineStack key={product._id} align="start">
                  <Thumbnail
                    source={product.images[0]?.src}
                    alt="Cover Photo"
                    size="large"
                  />

                  <div className={styles["view-product-list-item"]}>
                    <Text>{product.title}</Text>
                  </div>
                  <div>
                    {disabled ? (
                      ""
                    ) : (
                      <Button
                        onClick={() => {
                          handleProductSelection({
                            product,
                            variantId: selectedProduct.variantId,
                          });
                        }}
                      >
                        Remove
                      </Button>
                    )}
                  </div>
                </InlineStack>
                <DimensionBox
                  weight={selectedProduct.dimensions?.weight || ""}
                  height={selectedProduct.dimensions?.height || ""}
                  width={selectedProduct.dimensions?.width || ""}
                  length={selectedProduct.dimensions?.length || ""}
                  box={selectedProduct.dimensions.box}
                  editable={true}
                  onDimensionChange={(field, value) =>
                    handleDimensionChange(product._id, field, value)
                  }
                  boxes={boxes}
                />
                <br />
                <Divider />
                <br />
                {/* <InlineStack align="end">
                
                </InlineStack> */}
              </>
            );
          })}
        <br />

        <Button
          variant="primary"
          disabled={disabled}
          onClick={handleAddProducts}
        >
          Add Products
        </Button>
      </FormLayout>
      <br />

      {selectedBox ? (
        <Select
          label="Packaging"
          value={selectedBox}
          options={
            boxes?.length && selectedBox
              ? boxes.map((box) => ({
                  label: box?.name,
                  value: box?._id,
                }))
              : [{ label: "Select", value: null }]
          }
          onChange={(value) => setSelectedBox(value)}
          disabled={false}
        />
      ) : (
        <Text variant="bodyMd">
          No packaging available for this size. You can still create a bundle.
        </Text>
      )}
    </Card>
  );
};

export default SelectedProductsItems;
